<template>
    <div>
    <!-- action buttons -->
        <v-btn v-if="hasError || srcData.length===0"
               @click="startUploadAction()" class="mx-2 my-4">Spielplan importieren und prüfen</v-btn>
        <span v-else>
            <v-btn @click="createDBObjects()" class="mx-2 my-4"
                   color="success">Spiele aus Import anlegen</v-btn>
            <v-btn @click="startUploadAction()" class="mx-2 my-4">Neu aus Excel laden</v-btn>
        </span>
    <!-- hidden file upload button -->
        <div class="upload-btn-wrapper">
            <input ref="inputBtn" type="file" @change="selectFiles" accept=".xls,.xlsx,.csv" />
        </div>
    <!-- error message -->
        <div v-if="hasError" class="mx-3 mb-3 primary--text font-weight-bold">
            <v-icon color="primary" class="mr-2">mdi-alert</v-icon>
            Es ist zumindest ein Fehler aufgetreten, bitte die Tabelle prüfen!
        </div>
    <!-- search field-->
        <v-text-field v-if="srcData.length>0" v-model="search" prepend-inner-icon="mdi-magnify"
                      label="Suchen" filled dense light class="mt-3 mb-5 mx-2 white"
                      single-line hide-details>
            <template v-slot:append>
                <v-btn icon small class="pb-1">
                    <v-icon style="cursor: pointer" @click="search=''">mdi-close</v-icon>
                </v-btn>
            </template>
        </v-text-field>
    <!-- data table -->
        <v-data-table :headers="tableHeader" :items="srcData" :search="search" mobile-breakpoint="1"
                      class="elevation-2 ma-2" hide-default-footer disable-pagination>
            <!--<template v-slot:item.heimteam="{item}">
                {{getVereinForTable(item.HeimNr, item.Heim)}}
            </template>
            <template v-slot:item.gastteam="{item}">
                {{getVereinForTable(item.GastNr, item.Gast)}}
            </template>-->
            <template v-slot:item.termin="{item}">
                <div style="white-space: nowrap">
                    {{item.Datum}} {{item.Uhrzeit}}
                </div>
            </template>
            <template v-slot:item.status="{item}">
                <v-icon color="success" v-if="item.status">mdi-check</v-icon>
                <v-icon color="error" v-else>mdi-alert</v-icon>
            </template>
            <template v-slot:no-data>
                Noch keine Daten importiert!
            </template>
        </v-data-table>
    </div>
</template>

<script>
    import * as XLSX from 'xlsx';
    import TimeStamp from "../../services/timeStamp";
    import {Spiel} from "../../services/data/spiel";
    import {db} from "../../services/db";
    import SpielService from "../../services/data/spielService";
    export default {
        name: "saison-import",
        props: ['saison', 'isCup'],
        computed: {
            user(){ return this.$store.state.user; }
        },
        data: () => ({
            search: null,
            srcData: [],
            spiele: [],
        // file imports
            //importList: [],
            //importObj: null,
        // file import
            errorMsg: '',
            tableHeader: [
                {text: 'id', value: 'ID', sortable: true},
                /*{text: 'Heim', value: 'heimteam', sortable: true},
                {text: 'Gast', value: 'gastteam', sortable: true},*/
                {text: 'Heim-Nr', value: 'HeimNr', sortable: true},
                {text: 'Heim-Name', value: 'Heim', sortable: true},
                {text: 'Gast-Nr', value: 'GastNr', sortable: true},
                {text: 'Gast-Name', value: 'Gast', sortable: true},
                {text: 'Spieltermin', value: 'termin', sortable: true},
                {text: 'Ort', value: 'Ort', sortable: true},
                {text: 'Bahn', value: 'Bahn', sortable: true},
                {text: 'Runde', value: 'Runde', sortable: true},
                {text: 'Status', value: 'status', sortable: true},
                {text: 'Details', value: 'details', sortable: true},
            ],
        // data conversion
            teamsTemp: {},
            hasError: false,
        }),
        created(){
            if ( this.saison.lvId === '1' ) {
                for ( let i = 11; i <= 20; i++ ) {
                    if ( !this.$store.state.realtime.landesverbaende[i] ) {
                        if ( this.user.permissions.ergebnisdienst ) {
                            this.$store.dispatch('bindRealtimeDocument', {
                                collection: 'landesverbaende',
                                docId: i.toString(),
                                storeField: 'landesverbaende.' + i.toString(),
                                //emptyObject: new Landesverband()
                            });
                        }
                    }
                }
            }
        },
        methods: {
            startUploadAction(){
                this.clickInput();
            },
            clickInput () {
                this.$refs.inputBtn.click();
            },
            selectFiles(e) {
                if (e.target.files.length > 0) {
                    this.errorMsg = '';
                    this.fileSelected = true;
                    // Verarbeiten
                    this.transformToJSON(e, e.target.files[0].name);
                } else {
                    this.fileSelected = false;
                    this.fileBase64 = '';
                }
            },
            /*getVereinForTable(nr, team){
                if ( nr === 'spielfrei' ) {
                    return 'spielfrei';
                } else {
                    return nr + ' / ' + team
                }
            },*/
            transformToJSON(e){ //, fileName
                this.$store.state.local.loader = true;
                let files = e.target.files, f = files[0];
                let reader = new FileReader();
                reader.onload = (e) => {
                    try {
                        let data = new Uint8Array(e.target.result);
                        let workbook = XLSX.read(data, {type: 'array', cellText:false, cellDates:true});//type: 'array'
                        /*let workbook = XLSX.read(data, {type: 'binary',
                            cellDates: true,
                            cellNF: false,
                            cellText: false});//type: 'array'*/
                        let sheetName = workbook.SheetNames[0];
                        let worksheet = workbook.Sheets[sheetName];
                        // get data as array
                        let srcData = XLSX.utils.sheet_to_json(worksheet, {raw: false, dateNF: "mm/dd/yyyy hh:mm:ss"});//raw: true, defval: "", dateNF: "ISO", dateNF:"YYYY-MM-DD"
                        this.$refs.inputBtn.value = null;
                        this.srcData = srcData;
                        this.importSrcData();
                    }
                    catch (e) {
                        this.errorMsg = "err.noExcel";
                        this.$store.state.local.loader = false;
                    }
                };
                reader.readAsArrayBuffer(f);
            },
        // check and conversion of excel data
            importSrcData(){
                this.teamsTemp = JSON.parse(JSON.stringify(this.saison.teams));
                this.hasError = false;
                this.srcData.forEach( (row) => {
                    row.status = true;
                    row.details = '';
                    this.addTeamIdsForRow(row);
                    this.checkRunde(row);
                    const isSpielfrei = row.HeimNr==='spielfrei' || row.GastNr==='spielfrei';
                    row.type = isSpielfrei ? 'spielfrei' : 'spiel';
                    this.checkAndSetDate(row, isSpielfrei);
                    this.checkAndSetOrtAndBahn(row, isSpielfrei);
                });
            // await update and reset loader
                this.$store.state.local.loader = false;
            },
                addTeamIdsForRow(row){
                    if ( this.checkForRequiredFields(row, ['GastNr', 'Gast', 'HeimNr', 'Heim']) ) {
                        this.addTeamIds(row, row.GastNr, row.Gast, 'gastId');
                        this.addTeamIds(row, row.HeimNr, row.Heim, 'heimId');
                    }
                },
                    addTeamIds(row, vereinsNr, teamName, targetField) {
                        if ( vereinsNr !== 'spielfrei' ) {
                            let teamId = this.getExistingTeamTempId(row, vereinsNr, teamName);
                            if ( !teamId ) { //&& !this.hasError
                                teamId = this.addNewTeamToTeamTemp(vereinsNr, teamName)
                            }
                            if ( teamId ) {
                                row[targetField] = teamId
                            } else { //if (!this.hasError)
                                this.setError(row, 'Unbekannter Verein: ' + vereinsNr + " / " + teamName + '.');
                            }
                        }
                    },
                    getExistingTeamTempId(row, vereinsNr, teamName){
                        let countTeams = this.getNextTeamIdForTeamsTemp() - 1;
                        for ( let i = 1; i <= countTeams; i++ ) {
                            if ( this.teamsTemp[i] !== undefined ) {
                                const team = this.teamsTemp[i];
                                if ( teamName === team.name ) {
                                    if ( vereinsNr !== team.lvId + team.vereinsNr ) {
                                        this.setError(row, 'Für folgende Mannschaft ist bereits eine Mannschaft angelegt, ' +
                                            ' allerdings mit einer anderen Vereinsnummer (bitte prüfen): ' +
                                            vereinsNr + " / " + teamName + '.');
                                        return null
                                    }
                                    return i.toString();
                                }
                            }
                        }
                        return null;
                    },
                    addNewTeamToTeamTemp(vereinsNr, teamName){
                        const lv = SpielService.getLvIdFromVereinsNrLong(vereinsNr);
                        const vereinsNrShort = SpielService.getVereinsNrFromVereinsNrLong(vereinsNr);
                        const verein = this.$store.state.realtime.landesverbaende[lv].vereine[vereinsNrShort];
                        if ( !verein ) {
                            return null;
                        }
                        const id = (this.getNextTeamIdForTeamsTemp()).toString();
                        //const id = (Object.keys(this.teamsTemp).length + 1).toString();
                        this.teamsTemp[id] = {
                            lvId: lv,
                            name: teamName,
                            vereinsName: verein.name,
                            vereinsNr: vereinsNrShort,
                        };
                        return id;
                    },
                        getNextTeamIdForTeamsTemp(){
                            let newId = 1;
                            Object.keys(this.teamsTemp).forEach( (teamId) => {
                                if ( parseInt(teamId) >= newId ) { newId = parseInt(teamId) + 1 }
                            });
                            return newId;
                        },
                    checkAndSetOrtAndBahn(row, isSpielfrei){
                        if ( !isSpielfrei ) {
                            if ( !this.checkForRequiredFields(row, ['Ort', 'Bahn']) ) {
                                /*
                                const loadDatenblatt = await this.setVereinsdatenblatt(row);
                                if ( loadDatenblatt.successful ) {
                                    console.log ("Team", this.teamsTemp[row.gastId].local.sportanlage.ort);
                                    row.Ort = this.teamsTemp[row.gastId].local.sportanlage.ort;
                                }
                                */
                            }
                        } else {
                            row.Ort = '';
                            row.Bahn = '';
                        }
                    },
                        /*setVereinsdatenblatt(row){
                            return new Promise( (resolve) => {
                                const docRef = db.collection('vereinsdatenblaetter').doc(row.HeimNr);
                                docRef.get().then((doc) => {
                                    if (doc.exists) {
                                        this.teamsTemp[row.gastId].local = {
                                            sportanlage: doc.data().sportanlage,
                                        },
                                        resolve({successful: true})
                                    } else {
                                        // doc.data() will be undefined in this case
                                        resolve({successful: false, content: "No such document!"});
                                    }
                                }).catch((error) => {
                                    console.log("Error getting document:", error);
                                    resolve({successful: false, content: error})
                                });
                            })
                        },*/
                    checkAndSetDate(row, isSpielfrei){
                        if ( !isSpielfrei ) {
                            if ( this.checkForRequiredFields(row, ['Datum', 'Uhrzeit']) ) {
                                row.Datum = this.checkDateTimeType(row.Datum) ? TimeStamp.getDateStringFromSlashDateTimeUS(row.Datum) :
                                    this.setError(row, ' Datum fehlt.');
                                row.Uhrzeit = this.checkDateTimeType(row.Uhrzeit) ? TimeStamp.getTimeShortStringFromSlashDateTimeUS(row.Uhrzeit) :
                                    this.setError(row, ' Uhrzeit fehlt.');
                            }
                        } else {
                            row.Datum = '';
                            row.Uhrzeit = '';
                        }
                    },
                        checkDateTimeType(value){
                            return value && typeof value === 'string' && value.indexOf('.')===-1
                        },
                        checkRunde(row){
                            if ( this.checkForRequiredFields(row, ['Runde']) ) {
                                const rundeParts = row.Runde.split(' ');
                                if ( (rundeParts[1] !== 'F' && rundeParts[1] !== 'H' && rundeParts[1] !== 'C') ||
                                    isNaN(parseInt(rundeParts[0])) ||
                                    (rundeParts[1] === 'C' && !this.isCup)) {
                                    this.setError(row, ' Ungültige Runde.')
                                }
                            }
                        },
                        checkForRequiredFields(row, fieldList){
                            let rowText = JSON.stringify(row);
                            let fieldAvailable = true;
                            fieldList.forEach( (field) => {
                                if ( rowText.indexOf(field) === -1 ) {
                                    this.setError(row, "Wert für Spalte '" + field + "' fehlt! ");
                                    fieldAvailable = false;
                                }
                            });
                            return fieldAvailable;
                        },
                        setError(row, msg) {
                            row.status = false;
                            this.hasError = true;
                            row.details += msg;
                        },
        // create spiele and update saison
            createDBObjects(){
                this.$store.state.local.loader = true;
                this.createUpdatesOnSaison();
                this.updateInDB();
            },
                createUpdatesOnSaison(){
                    this.addSpielfreiUpdates();
                    this.addTeamUpdates();
                },
                    addSpielfreiUpdates(){
                        let spielfrei = this.srcData.filter(spiele => spiele.type === 'spielfrei');
                        spielfrei.forEach( (item) => {
                            const teamId = item.gastId ? item.gastId: item.heimId;
                            const runde = item.Runde.replace(' ', '_');
                            const key = 'spielfrei.' + runde + '.' + teamId;
                            this.saison.local.documentUpdates[key] = true;
                        });
                    },
                    addTeamUpdates(){
                        this.saison.local.documentUpdates.teams = JSON.parse(JSON.stringify(this.teamsTemp));
                    },
                        /*cleanTeamsTemp(){
                            let teams = JSON.parse(JSON.stringify(this.teamsTemp));
                            teams.forEach( (item) => {
                                delete item.local;
                            });
                            return teams;
                        },*/

            async updateInDB(){
                let promiseList = [];
                this.spiele = [];
            // get spiel creations
                let spieleRaw = this.srcData.filter(spiele => spiele.type === 'spiel');
                spieleRaw.forEach( (spiel) => {
                    let spielTemp = this.getSpielObject(spiel);
                    this.spiele.push(spielTemp);
                });
                this.spiele.forEach( (spiel) => {
                    promiseList.push(this.getCreatePromiseForSpiel(spiel));
                });
            // process with promise all
                this.processUpdates(promiseList);
            },
                getSpielObject(row){
                    const spiel = new Spiel(this.saison.anzahlSpieler,
                                            this.saison.anzahlErsatzSpieler,
                                            this.saison.eintauschVorEinspielzeit,
                                            this.saison.freieSpieler,
                                            this.isCup);
                // set saison data
                    const rundeParts = row.Runde.split(' ');
                    spiel.saison.id = this.saison.id;
                    spiel.saison.semester = rundeParts[1] === 'C' ? 'A' : rundeParts[1];
                    spiel.saison.runde = rundeParts[0];
                    spiel.saison.lvId = this.saison.lvId;
                // set teams
                    const gastTeam = this.teamsTemp[row.gastId];
                    spiel.gast.teamId = row.gastId;
                    spiel.gast.teamName = gastTeam.name;
                    spiel.gast.vereinsNr = gastTeam.lvId + gastTeam.vereinsNr;
                    spiel.gast.vereinsName = gastTeam.vereinsName;
                    const heimTeam = this.teamsTemp[row.heimId];
                    spiel.heim.teamId = row.heimId;
                    spiel.heim.teamName = heimTeam.name;
                    spiel.heim.vereinsNr = heimTeam.lvId + heimTeam.vereinsNr;
                    spiel.heim.vereinsName= heimTeam.vereinsName;
                // set infos
                    spiel.infos = {
                        wochentag: row.Wochentag,
                        datum: row.Datum,
                        uhrzeit: row.Uhrzeit,
                        ort: row.Ort,
                        bahn: row.Bahn,
                        kommentar: '',
                        kommentarStrafe: '',
                        stream: '',
                    };
                // set spiel pending for heim
                    spiel.setPending(); // must be after definiton of mannschaften
                    return spiel;
                },
                getCreatePromiseForSpiel(spiel){
                    const dbData = spiel.getDbObject();
                    return new Promise( (resolve) => {
                        db.collection('spiele')
                            .add( dbData )
                            .then((docRef) => {
                                console.log("Spiel successfully created!");
                                spiel.id = docRef.id;
                                resolve('done');
                            })
                            .catch((error) => {
                                console.error("Error updating document: ", error);
                                resolve('done');
                            });
                    });
                },
            processUpdates(promiseList){
                return new Promise( (resolve) => {
                    Promise.all(promiseList).then( () => {
                        this.getDocumentUpdatesFromSpieleList();
                        this.srcData = [];
                        resolve('done');
                    });
                })
            },
            async getDocumentUpdatesFromSpieleList(){
                this.spiele.forEach( (spiel) => {
                    const key = 'spiele.' + spiel.id;
                    const obj = SpielService.getExcerptForSaison(spiel);
                    //delete obj.partien;
                    this.saison.local.documentUpdates[key] = obj;
                });
                const reply = await this.saison.saveEdited('saison_edit'); //this.getSaisonUpdatePromise;
                this.$store.state.local.loader = false;
                return reply;
            }
        },
        watch: {
            saison: {
                handler(to, from){
                    if ( to && !from ) {
                        this.srcData = [];
                        this.spiele = [];
                    }
                },
                deep: true
            },
        }
    }
</script>

<style scoped>
    .upload-btn-wrapper {
        position: relative;
        overflow: hidden;
        display: inline-block;
    }
    .upload-btn-wrapper input[type=file] {
        font-size: 100px;
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0;
    }
</style>